var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1928.724,
    height: 734.851,
    viewBox: "0 0 1928.724 734.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 1283.192,
    y: 135.992,
    width: 228.557,
    height: 228.557,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#58a596",
    floodOpacity: 0.133
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 1040.989,
    y: 452.655,
    width: 228.557,
    height: 228.557,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#58a596",
    floodOpacity: 0.133
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 676.867,
    y: 243.183,
    width: 228.557,
    height: 228.557,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#58a596",
    floodOpacity: 0.133
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 315.199,
    y: 453.474,
    width: 228.557,
    height: 228.557,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#58a596",
    floodOpacity: 0.133
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.046 -2077.477)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(742.823 2542.763)",
    fill: "#273e4f",
    fontSize: 25,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Je la "), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 38
  }, "pr\xE9pare"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(367.245 2765.328)",
    fill: "#273e4f",
    fontSize: 25,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Je re\xE7ois"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 38
  }, "l\u2019ordonnance"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1095.49 2746.508)",
    fill: "#273e4f",
    fontSize: 25,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Mon patient "), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 38
  }, "est inform\xE9"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1357.331 2442.936)",
    fill: "#273e4f",
    fontSize: 25,
    fontFamily: "Poppins-Light, Poppins",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Il vient r\xE9cup\xE9rer "), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 38
  }, "sa commande"))), /*#__PURE__*/React.createElement("path", {
    d: "M-235.332,2462.517S100.3,2867.654,226.543,2867.654s192.411-227.328,332.972-226.226,180.76,224.8,326.009,226.226,163.84-203.808,234.126-297.536,572.9-281.922,572.9-281.922",
    transform: "translate(226.864 -210.017)",
    fill: "none",
    stroke: "#5cbe8e",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.05, 2077.48)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.278,
    cy: 66.278,
    rx: 66.278,
    ry: 66.278,
    transform: "translate(1331.19 183.99)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.05, 2077.48)",
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.278,
    cy: 66.278,
    rx: 66.278,
    ry: 66.278,
    transform: "translate(1088.99 500.66)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.05, 2077.48)",
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.278,
    cy: 66.278,
    rx: 66.278,
    ry: 66.278,
    transform: "translate(724.87 291.18)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.05, 2077.48)",
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.278,
    cy: 66.278,
    rx: 66.278,
    ry: 66.278,
    transform: "translate(363.2 501.47)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(376.351 2616.925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.489,2.939H21.04a4.579,4.579,0,0,0-4.574,4.574v7.3L2.6.947A1.525,1.525,0,0,0,.447,3.1L18.406,21.062,8.917,30.55,2.6,24.236A1.525,1.525,0,0,0,.447,26.393L13.12,39.066l0,1.372a15.747,15.747,0,0,0,3.348,9.683v9.841a4.579,4.579,0,0,0,4.574,4.574H73.489a4.579,4.579,0,0,0,4.574-4.574V25.2a1.525,1.525,0,0,0-3.049,0V59.962a1.526,1.526,0,0,1-1.525,1.525H41.659c.064-.057.126-.115.188-.176A4.372,4.372,0,0,0,42.75,60a4.4,4.4,0,0,0,5.907-5.9,4.4,4.4,0,0,0,1.313-7.132L44.72,41.708a4.851,4.851,0,0,0,4.271-1.97l.05-.068a4.951,4.951,0,0,0-1.029-6.879c-1.366-1.015-3.215-2.4-5.5-4.1a18.759,18.759,0,0,0-11.166-3.714h-.02l-4.694,0-7.118-7.118V7.513A1.526,1.526,0,0,1,21.04,5.989H36.958V21.537a1.525,1.525,0,0,0,2.6,1.079L42.874,19.3l3.313,3.313a1.524,1.524,0,0,0,2.156,0L51.656,19.3l3.313,3.313a1.525,1.525,0,0,0,2.6-1.078V5.989H73.489a1.526,1.526,0,0,1,1.525,1.525V13a1.525,1.525,0,0,0,3.049,0V7.513A4.579,4.579,0,0,0,73.489,2.939ZM19.516,59.962V53.331L24.5,58.313h0l3.173,3.173H21.04A1.526,1.526,0,0,1,19.516,59.962ZM31.331,28.021h.017a15.689,15.689,0,0,1,9.339,3.107c2.286,1.71,4.139,3.093,5.507,4.109a1.893,1.893,0,0,1,.387,2.631l-.05.068a1.8,1.8,0,0,1-2.424.449l-5.851-3.772a1.767,1.767,0,0,0-2.207,2.735L47.815,49.116a1.352,1.352,0,0,1-1.794,2.018l-5.905-5.905a1.518,1.518,0,0,0-.127-.113l-.6-.6a1.525,1.525,0,0,0-2.157,2.156l6.517,6.517c.067.067.138.132.208.194L45.674,55.1a1.353,1.353,0,1,1-1.914,1.913L42.04,55.292c-.062-.07-.126-.14-.194-.208l-5.793-5.793a1.626,1.626,0,0,0-.128-.113l-.6-.6a1.525,1.525,0,0,0-2.156,2.156l6.629,6.629a1.353,1.353,0,0,1-2.018,1.794L35.852,57.23c-.063-.071-.127-.141-.194-.208l-3.666-3.667a1.629,1.629,0,0,0-.128-.113l-.6-.6A1.525,1.525,0,0,0,29.1,54.794l4.5,4.5a1.353,1.353,0,0,1-2.018,1.794L23.6,53.1v0l-3.749-3.749a12.664,12.664,0,0,1-3.684-8.91l0-2.216,10.2-10.2Zm-17.1,7.839-3.154-3.153,9.489-9.489,3.154,3.154Zm40.3-18-1.788-1.789a1.525,1.525,0,0,0-2.156,0l-3.313,3.313-3.313-3.313a1.524,1.524,0,0,0-2.156,0l-1.789,1.789V5.989H54.522Zm0,0",
    transform: "translate(0 -0.5)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.283,299.656h-9.758a1.525,1.525,0,1,0,0,3.049h9.758a1.525,1.525,0,1,0,0-3.049Zm0,0",
    transform: "translate(-316.977 -254.045)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.8,340.9h-6.607a1.525,1.525,0,1,0,0,3.049H402.8a1.525,1.525,0,0,0,0-3.049Zm0,0",
    transform: "translate(-334.494 -289.002)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.193,340.9a1.525,1.525,0,1,0,1.078.447A1.533,1.533,0,0,0,356.193,340.9Zm0,0",
    transform: "translate(-300.593 -288.999)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.525,112.488a1.525,1.525,0,1,0,1.078.447A1.537,1.537,0,0,0,493.525,112.488Zm0,0",
    transform: "translate(-416.986 -95.414)",
    fill: "#58a596"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(749.23 2402.069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448,448h2.191v2.191H448Z",
    transform: "translate(-388.836 -388.836)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,448h2.191v2.191H304Z",
    transform: "translate(-264.557 -388.836)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,320h2.191v2.191H448Z",
    transform: "translate(-388.836 -278.366)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.539,96H212.817a1.1,1.1,0,0,0-1.1,1.1v33.965H193.1a1.1,1.1,0,0,0-1.1,1.1v17.53a1.1,1.1,0,0,0,1.1,1.1h39.443a1.1,1.1,0,0,0,1.1-1.1V97.1A1.1,1.1,0,0,0,232.539,96Zm-12.052,37.252h4.383v4.383h-4.383Zm-6.574-2.191V115.722H218.3V121.2a1.1,1.1,0,0,0,1.1,1.1h6.574a1.1,1.1,0,0,0,1.1-1.1v-5.478h4.383v15.339Zm6.574-15.339h4.383V120.1h-4.383Zm0-17.53h4.383v4.383h-4.383Zm-6.574,0H218.3v5.478a1.1,1.1,0,0,0,1.1,1.1h6.574a1.1,1.1,0,0,0,1.1-1.1V98.191h4.383V113.53h-17.53Zm-13.148,35.06h4.383v4.383h-4.383Zm-6.574,0h4.383v5.478a1.1,1.1,0,0,0,1.1,1.1h6.574a1.1,1.1,0,0,0,1.1-1.1v-5.478h4.383v15.339h-17.53Zm37.252,15.339h-17.53V133.252H218.3v5.478a1.1,1.1,0,0,0,1.1,1.1h6.574a1.1,1.1,0,0,0,1.1-1.1v-5.478h4.383Z",
    transform: "translate(-167.896 -85.044)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,192h2.191v2.191H448Z",
    transform: "translate(-388.836 -167.896)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.191,22.574h3.287v4.383a3.287,3.287,0,1,0,6.574,0V24.765H25.861v2.191a1.1,1.1,0,1,1-2.191,0V20.383a2.191,2.191,0,1,1,4.383,0H25.861v2.191H47.774v6.574a1.1,1.1,0,0,0,1.1,1.1h6.574V59.826h2.191V29.148a1.1,1.1,0,0,0-.321-.775L49.644,20.7a1.1,1.1,0,0,0-.775-.321H30.243a4.383,4.383,0,0,0-8.765,0H17.1a1.1,1.1,0,0,0-1.1,1.1V76.26a1.1,1.1,0,0,0,1.1,1.1H37.913V75.165H18.191Zm31.774,1.549,3.929,3.929H49.965Z",
    transform: "translate(-16 -16)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,256h2.191v2.191H72Z",
    transform: "translate(-64.331 -223.131)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,256h24.1v2.191H104Z",
    transform: "translate(-91.948 -223.131)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,288H86.678v2.191H56Z",
    transform: "translate(-50.522 -250.748)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,320H86.678v2.191H56Z",
    transform: "translate(-50.522 -278.366)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,352H71.339v2.191H56Z",
    transform: "translate(-50.522 -305.983)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,384H66.956v2.191H56Z",
    transform: "translate(-50.522 -333.601)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,128.765v.16a3.133,3.133,0,0,0,2.191,2.984v1.239h2.191v-1.239a3.127,3.127,0,0,0,.463-5.781l-2.136-1.068a.936.936,0,0,1,.418-1.773h.32a.937.937,0,0,1,.936.936v.16h2.191v-.16a3.133,3.133,0,0,0-2.191-2.984V120h-2.191v1.239a3.127,3.127,0,0,0-.463,5.781l2.137,1.068a.936.936,0,0,1-.418,1.773h-.32a.937.937,0,0,1-.936-.936v-.16Z",
    transform: "translate(-126.47 -105.757)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,160h2.191v2.191H112Z",
    transform: "translate(-98.852 -140.279)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,160h2.191v2.191H208Z",
    transform: "translate(-181.705 -140.279)",
    fill: "#58a596"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1115.946 2611.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.156,45.118h0c-1.9,0-2.979-.989-3.594-3.3-.629-2.365-.65-5.8-.672-9.427-.027-4.4-.057-9.387-1.151-13.847a.984.984,0,0,0-1.911.468c1.039,4.235,1.068,9.1,1.095,13.391.023,3.761.044,7.312.738,9.92a7.9,7.9,0,0,0,1.293,2.8H9.972a7.9,7.9,0,0,0,1.293-2.8c.694-2.608.715-6.16.738-9.92.035-5.741.075-12.249,2.424-17.229,2.644-5.606,7.889-8.331,16.034-8.331,4.473,0,8.134.841,10.879,2.5a13.2,13.2,0,0,1,5.344,6.247.984.984,0,0,0,1.8-.791,15.307,15.307,0,0,0-6.128-7.14A18.663,18.663,0,0,0,36.3,5.406a5.857,5.857,0,0,0-11.679,0,18.84,18.84,0,0,0-5.816,2.106,15.165,15.165,0,0,0-6.159,6.82c-2.534,5.373-2.575,12.111-2.611,18.056-.022,3.632-.043,7.062-.672,9.427-.615,2.313-1.69,3.3-3.594,3.3h0a5.766,5.766,0,0,0,0,11.532H11.99a.983.983,0,1,0,0-1.967H5.766a3.8,3.8,0,0,1,0-7.6H55.157a3.8,3.8,0,0,1,0,7.6H15.924a.983.983,0,0,0,0,1.967h4.037a10.546,10.546,0,0,0,21,0H55.156a5.766,5.766,0,0,0,0-11.532ZM30.461,1.967a3.9,3.9,0,0,1,3.816,3.125,33.732,33.732,0,0,0-7.631,0A3.9,3.9,0,0,1,30.461,1.967Zm0,62.281a8.593,8.593,0,0,1-8.523-7.6H38.984A8.593,8.593,0,0,1,30.461,64.248Zm0,0",
    transform: "translate(0)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.246,35.318a12.755,12.755,0,0,1,3.491,3.33,18.911,18.911,0,0,1,3.477,11.544.984.984,0,1,0,1.967,0,20.866,20.866,0,0,0-3.934-12.809A14.373,14.373,0,0,0,355.2,33.6a.984.984,0,0,0-.954,1.72Zm0,0",
    transform: "translate(-307.995 -29.146)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.987,38.327c.158.1,3.876,2.6,3.876,8.876a.983.983,0,0,0,1.967,0c0-7.4-4.586-10.408-4.782-10.532a.983.983,0,0,0-1.06,1.656Zm0,0",
    transform: "translate(-358.317 -31.794)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.331,51.174a.984.984,0,0,0,.984-.984,18.914,18.914,0,0,1,3.477-11.544,12.8,12.8,0,0,1,3.491-3.33.983.983,0,0,0-.954-1.72,14.374,14.374,0,0,0-4.047,3.785,20.87,20.87,0,0,0-3.934,12.809A.983.983,0,0,0,45.331,51.174Zm0,0",
    transform: "translate(-38.612 -29.145)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.874,48.186a.983.983,0,0,0,.983-.983c0-6.272,3.712-8.769,3.876-8.875a.983.983,0,0,0-1.06-1.656c-.195.124-4.782,3.128-4.782,10.532A.983.983,0,0,0,11.874,48.186Zm0,0",
    transform: "translate(-9.482 -31.795)",
    fill: "#58a596"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1357.572 2294.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216,128h2.2v2.2H216Z",
    transform: "translate(-190.657 -112.574)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,128h2.2v2.2H280Z",
    transform: "translate(-245.842 -112.574)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.306,182.755A3.035,3.035,0,0,0,238.611,180h-2.2c0,.194-.418.551-1.1.551s-1.1-.357-1.1-.551H232A3.035,3.035,0,0,0,235.306,182.755Z",
    transform: "translate(-204.453 -157.411)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.962,63.487,86.771,59.3l-1.558,1.558L89.4,65.045a7.116,7.116,0,0,1,2.1,5.065v6.769a3.034,3.034,0,0,1-3.03,3.03H85.992V74.4h2.2V72.2H83.788V52.362a1.1,1.1,0,0,0-1.1-1.1H76.711l-6.285-4-.912-3.648.386-.2a5.209,5.209,0,0,0,2.87-4.669v-.71h.551a3.861,3.861,0,0,0,3.857-3.857v-1.1A3.861,3.861,0,0,0,73.4,29.224a3.853,3.853,0,0,0,.468-1.842V23.989A8,8,0,0,0,65.883,16h-6.06a8,8,0,0,0-7.989,7.989v3.392a3.853,3.853,0,0,0,.468,1.842,3.861,3.861,0,0,0-3.774,3.856v1.1a3.861,3.861,0,0,0,3.857,3.857h.551v.752a5.205,5.205,0,0,0,2.893,4.681l.353.177-.9,3.613-6.285,4H43.019a1.1,1.1,0,0,0-1.1,1.1v3.951L37.832,60.4l1.558,1.558,2.526-2.526V72.2H37.509v2.2h2.2v5.509H37.234a3.034,3.034,0,0,1-3.03-3.03V70.11a7.116,7.116,0,0,1,2.1-5.065l.885-.885L35.628,62.6l-.885.885A9.3,9.3,0,0,0,32,70.11v6.769a5.24,5.24,0,0,0,5.234,5.234H88.471a5.24,5.24,0,0,0,5.234-5.234V70.11a9.3,9.3,0,0,0-2.743-6.623ZM59.547,53.464h6.611v7.713H59.547Zm8.17-2.2,1.9-1.9,2.988,1.9ZM54.91,28.838a1.629,1.629,0,0,1-.873-1.457v-.816l4-2.222a9.859,9.859,0,0,1,9.632,0l4,2.222v.816a1.653,1.653,0,0,1-2.57,1.375L66.52,27.038a6.593,6.593,0,0,0-7.335,0l-2.578,1.719A1.629,1.629,0,0,1,54.91,28.838Zm20.063,4.241v1.1a1.655,1.655,0,0,1-1.653,1.653h-.551V31.426h.551a1.655,1.655,0,0,1,1.653,1.653ZM59.822,18.2h6.06a5.791,5.791,0,0,1,5.785,5.785v.055l-2.929-1.627a12.049,12.049,0,0,0-11.772,0l-2.929,1.627v-.055A5.791,5.791,0,0,1,59.822,18.2Zm-7.438,17.63a1.655,1.655,0,0,1-1.653-1.653v-1.1a1.655,1.655,0,0,1,1.653-1.653h.551v4.408Zm2.755,2.956V31.2a3.848,3.848,0,0,0,2.69-.609l2.578-1.719a4.4,4.4,0,0,1,4.89,0l2.578,1.719a3.85,3.85,0,0,0,2.69.609v7.549a3.016,3.016,0,0,1-1.661,2.7l-5.313,2.69a1.66,1.66,0,0,1-1.486,0L56.814,41.5a3.014,3.014,0,0,1-1.675-2.71Zm5.981,7.328a3.873,3.873,0,0,0,3.467-.009L67.5,44.634l.746,2.983L64.6,51.26H61.105l-3.644-3.644.74-2.959Zm-5.033,3.242,1.9,1.9H53.1Zm-11.967,4.1H57.343v8.815a1.1,1.1,0,0,0,1.1,1.1H67.26a1.1,1.1,0,0,0,1.1-1.1V53.464H81.584V72.2h-1.1a8.829,8.829,0,0,0-8.746,7.713H68.362V74.4a1.1,1.1,0,0,0-1.1-1.1H58.445a1.1,1.1,0,0,0-1.1,1.1v5.509H53.969A8.829,8.829,0,0,0,45.222,72.2h-1.1Zm-2.2,26.445V74.4h3.306a6.622,6.622,0,0,1,6.519,5.509Zm17.63,0V75.5h6.611v4.408Zm24.241,0H73.963A6.622,6.622,0,0,1,80.483,74.4h3.306Z",
    transform: "translate(-32 -16)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,304h2.2v2.2H136Z",
    transform: "translate(-121.675 -264.332)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,304h4.408v2.2H168Z",
    transform: "translate(-149.268 -264.332)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,336h8.815v2.2H136Z",
    transform: "translate(-121.675 -291.925)",
    fill: "#58a596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.1,311.713h3.857a3.861,3.861,0,0,0,3.857-3.857V305.1a1.1,1.1,0,0,0-1.1-1.1h-3.857A3.861,3.861,0,0,0,312,307.857v2.755A1.1,1.1,0,0,0,313.1,311.713Zm1.1-3.857a1.655,1.655,0,0,1,1.653-1.653h2.755v1.653a1.655,1.655,0,0,1-1.653,1.653H314.2Z",
    transform: "translate(-273.434 -264.332)",
    fill: "#58a596"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLine);
export default __webpack_public_path__ + "static/media/desktop-line.64ebe4ba14b5ed4f58b0f3696cbb9469.svg";
export { ForwardRef as ReactComponent };